import React, { useEffect, useState, useCallback, useRef } from 'react';
import Table from '../../components/Table/indexAgent';
import LeadService from '../../core/services/leadsService';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Avatar from '@mui/material/Avatar';
import { Card, Box, Switch } from '@mui/material';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Autocomplete } from '@mui/material';
import { debounce, throttle } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import Chip from '@mui/material/Chip';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { useDateTime } from '../../pages/ContextDateandTime/DateTimeContext';
import { styled, Dialog, TextField, InputAdornment, DialogContentText, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';
import '../ServicesMenu/servicesMenu.css';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { GlobalStyles, textAlign } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import dayjs from 'dayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import SuperAdmin_Cards from './SuperAdmin_Cards';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';

const useStyles = makeStyles((theme) => ({
    superAdminAgentFilter: {
        width: '250px',
        [theme.breakpoints.down('md')]: {},
    },
    SuperAdminAgentsContainer: {
        // [theme.breakpoints.down('xsm')]: {
        //     width: '1050px',
        //     margin: '0 auto',
        // },
        // [theme.breakpoints.between('md', 'lg')]: {
        //     width: '1150px',
        //     margin: '0 auto',
        // },
        // [theme.breakpoints.between('md', 'xmd')]: {
        //     width: '1080px',
        //     margin: '0 auto',
        // },
        // [theme.breakpoints.up('lg')]: {
        //     width: '1590px',
        //     margin: '0 auto',
        // },
        // [theme.breakpoints.up('macScreen')]: {
        //     width: '1380px',
        // },
    },
    tableOverviewStyle: {
        width: '100%',
        overflow: 'visible',
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1080px',
            overflow: 'visible',
        },
    },
}));
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',
};
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Super_Admin_Agents = () => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const getInitialButtonVisibility = () => {
        const emailSentTimestamp = localStorage.getItem('emailSentTimestamp');
        if (emailSentTimestamp) {
            const timeElapsed = Date.now() - parseInt(emailSentTimestamp, 10);
            return timeElapsed >= 480000;
        }
        return true;
    };

    const [GetAllAgents, setGetAllAgents] = React.useState([]);
    const [deleteId, setDeleteId] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageRef, setCurrentPageRef] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [PauseLoading, setPauseLoading] = useState(false);
    const [emailShowTooltip, setEmailShowTooltip] = React.useState(false);
    const { selectedIds, setSelectedIds, setRowSelection } = useDateTime();
    const [isLoadingEmail, setIsLoadingEmail] = useState(false);
    const [buttonVisible, setButtonVisible] = useState(getInitialButtonVisibility);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermRefer, setSearchTermRefer] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');
    const [selectedOrganization, setSelectedOrganization] = useState('');
    const [getPefferedLocation, setGetPefferedLocation] = useState();
    const [getOrganization, setGetOrganization] = useState();
    const [selectedFilterValue, setSelectedFilterValue] = useState('');
    const [selectedRefer, setSelectedRefer] = useState('');
    const [getReferCode, setGetReferCode] = useState([]);
    const [loading, setLoading] = useState(false);
    const [logOutModal, setLogOutModal] = React.useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [IsLoadingRef, setIsLoadingRef] = useState(false);
    const [fromDate, setFromDate] = React.useState('');
    const [toDate, setToDate] = useState('');
    const [formattedFromDate, setFormattedFromDate] = useState('');
    const [formattedToDate, setFormattedToDate] = useState('');
    const [SubscriptionType, setSubscriptionType] = useState([]);
    const [SubscriptionDevice, setSubscriptionDevice] = useState('');
    const [tags, setTags] = useState([]); // To store tags data from API
    const [selectedTags, setSelectedTags] = useState([]);
    const [sendIDsToAPI, setSendIDsToAPI] = useState([]);
    const abortControllerRef = useRef(null);
    const searchTermRef = useRef(searchTerm);
    const selectedValueRef = useRef(selectedValue);
    const selectedFilterValueRef = useRef(selectedFilterValue);
    const selectedFilterRef = useRef(selectedRefer);
    const selectedLocationRef = useRef(selectedLocation);
    const selectedOrganizationRef = useRef(selectedOrganization);
    const SubscriptionDeviceRef = useRef(SubscriptionDevice);
    const selectedTagsRef = useRef(sendIDsToAPI);
    const [trailModal, setTrailModal] = useState(false);
    const [selectedDays, setSelectedDays] = useState(null);
    const [updatedDate, setUpdatedDate] = useState(null);
    const [currentId, setCurrentId] = useState(null);
    const [LoadingTrial, setLoadingTrial] = useState(false);
    const [openConfirmationMandatory, setOpenConfirmationMandatory] = useState(false);
    const [switchLoading, setSwitchLoading] = useState(false);

    const [confirmationDataMandatory, setConfirmationDataMandatory] = useState({ id: null, SwitchCustomer: null });
    const lastScrollTopRef = useRef(0);
    const searchRefBy = useRef('');

    const GetIosAndroidSubscriptionVersions = async () => {
        try {
            const res = await LeadService.GetOsAndroidSubscriptionTypeVersion();
            if (res?.data?.success) {
                setSubscriptionType(res?.data?.subscription_types);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };
    useEffect(() => {
        GetIosAndroidSubscriptionVersions();
    }, []);

    const HandleChangeSubscriptionType = (event, newValue) => {
        if (newValue) {
            const newStoredValue = newValue;
            setSubscriptionDevice(newStoredValue);
            localStorage.setItem('SubscriptionDevice', JSON.stringify(newStoredValue));
        } else {
            setSubscriptionDevice(null);
            localStorage.removeItem('SubscriptionDevice');
        }
    };

    const options = [
        { label: 'New User', value: '' },
        { label: 'Last Login', value: 'last_login' },
    ];
    const filterOptions = [
        { label: 'All', value: '' },
        { label: 'Active', value: 'active' },
        { label: 'In Active ', value: 'inactive' },
        { label: 'Paused', value: 'paused' },
        { label: 'Deleted', value: 'deleted' },
        // { label: 'Imported Agent', value: 'imported' },
    ];

    const AllLocation = async () => {
        try {
            const res = await LeadService.getLocationForAgent();
            if (res.data.success) {
                setGetPefferedLocation(res.data.data);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };
    const AllReferCode = async (currentPageRef, searchTermRefer = '', isPaginatedRef, signal) => {
        try {
            setIsLoadingRef(true);
            const isPaginatedRef = true;
            const res = await LeadService.getReferCode(currentPageRef, searchTermRefer, isPaginatedRef, signal);
            if (res.data.success) {
                // Transform the data to match Autocomplete's format
                const formattedData =
                    res?.data?.data?.data?.map((item) => ({
                        label: `${item?.name || ''} ${item?.last_name || ''}`,
                        value: item?.referral_code,
                    })) || [];

                setHasMore(res?.data?.data?.data?.length > 0);
                setGetReferCode((prevCodes) => [...prevCodes, ...formattedData]); // Merge new data with existing state
                setCurrentPageRef(currentPageRef);
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoadingRef(false);
        }
    };

    const debouncedAllReferCode = useCallback(
        // Use a debounced version of fetchLocations
        debounce((currentPageRef, searchTermRefer) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            AllReferCode(currentPageRef, searchTermRefer, abortController.signal);
        }, 300),
        []
    );

    useEffect(() => {
        debouncedAllReferCode(currentPageRef, searchTermRefer);
    }, [currentPageRef, searchTermRefer, debouncedAllReferCode]);

    const handleScroll = useCallback(
        debounce((e) => {
            if (loading || !hasMore) return; // If loading or no more data, do nothing

            const { scrollTop, scrollHeight, clientHeight } = e.target;
            const isScrollingDown = scrollTop > lastScrollTopRef.current;

            if (isScrollingDown && scrollTop + clientHeight >= scrollHeight - 5) {
                setCurrentPageRef((prevPage) => prevPage + 1);
            }

            lastScrollTopRef.current = scrollTop;
        }, 200), // Adjust debounce time as needed
        [loading, hasMore]
    );
    const handleInputChange = (event, value) => {
        searchRefBy.current = value;
        setSearchTermRefer(value);
        if (value.trim() !== '') {
            debouncedAllReferCode(1, value);
        } else {
            setCurrentPageRef(1);
            setHasMore(false);
        }
    };
    const AllOrganization = async () => {
        try {
            const res = await LeadService.getOrganizations();
            if (res.data.success) {
                setGetOrganization(res.data.data);

                // const importedAgent = { id: '', organization_name: 'Imported/SelfPay Agent' };
                // const organizations = [importedAgent, ...res.data.data];

                // setGetOrganization(organizations);
                // // Set the default selected organization
                // setSelectedOrganization(importedAgent.id);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        AllLocation();
        AllOrganization();
    }, []);

    const getAgents = async (
        page,
        searchTerm = '',
        selectedValue = '',
        selectedFilterValue = '',
        selectedLocation = '',
        selectedOrganization,
        selectedRefer,
        signal,
        fromDate = '',
        toDate = '',
        SubscriptionDevice = '',
        sendIDsToAPI = []
    ) => {
        setIsLoading(true);
        try {
            const isPaginated = 1;
           
            const CommaSeparateSelectedTagsIds = sendIDsToAPI.join(',');
            const res = await LeadService.getAgentsApi(
                page,
                searchTerm,
                selectedValue,
                selectedFilterValue,
                selectedLocation,
                selectedOrganization,
                selectedRefer,
                isPaginated,
                { signal },
                fromDate,
                toDate,
                SubscriptionDevice,
                CommaSeparateSelectedTagsIds
            );
            if (res?.data?.success) {
                setGetAllAgents(res?.data?.agents?.data);
                setCurrentPage(res?.data?.agents?.current_page);
                setTotalPages(Math.ceil(res?.data?.agents?.total / res?.data?.agents?.per_page));
                return;
            }
        } catch (error) {
            toast.error(error.message);
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    // Throttled function to ensure a minimum delay of 2 seconds between calls
    const throttledGetAgents = useCallback(
        throttle(
            (
                page,
                searchTerm,
                selectedValue,
                selectedFilterValue,
                selectedLocation,
                selectedOrganization,
                selectedRefer,
                signal,
                fromDate,
                toDate,
                SubscriptionDevice,
                sendIDsToAPI
            ) => {
                getAgents(
                    page,
                    searchTerm,
                    selectedValue,
                    selectedFilterValue,
                    selectedLocation,
                    selectedOrganization,
                    selectedRefer,
                    signal,
                    fromDate,
                    toDate,
                    SubscriptionDevice,
                    sendIDsToAPI
                );
            },
            2000
        ),
        []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchAgents = useCallback(
        debounce(
            (
                page,
                searchTerm,
                selectedValue,
                selectedFilterValue,
                selectedLocation,
                selectedOrganization,
                selectedRefer,
                fromDate,
                toDate,
                SubscriptionDevice,
                sendIDsToAPI
            ) => {
                if (abortControllerRef.current) {
                    abortControllerRef.current.abort();
                }
                const abortController = new AbortController();
                abortControllerRef.current = abortController;
                throttledGetAgents(
                    page,
                    searchTerm,
                    selectedValue,
                    selectedFilterValue,
                    selectedLocation,
                    selectedOrganization,
                    selectedRefer,
                    abortController.signal,
                    fromDate,
                    toDate,
                    SubscriptionDevice,
                    sendIDsToAPI
                );
            },
            500
        ),
        [throttledGetAgents]
    );

    useEffect(() => {
        searchTermRef.current = searchTerm;
        selectedValueRef.current = selectedValue;
        selectedFilterValueRef.current = selectedFilterValue;
        selectedLocationRef.current = selectedLocation;
        selectedOrganizationRef.current = selectedOrganization;
        selectedFilterRef.current = selectedRefer;
        SubscriptionDeviceRef.current = SubscriptionDevice;
        selectedTagsRef.current = sendIDsToAPI;
        fetchAgents(
            currentPage,
            searchTerm,
            selectedValue,
            selectedFilterValue,
            selectedLocation,
            selectedOrganization,
            selectedRefer,
            formattedFromDate,
            formattedToDate,
            SubscriptionDevice,
            sendIDsToAPI
        );
    }, [
        currentPage,
        searchTerm,
        selectedValue,
        selectedFilterValue,
        selectedLocation,
        selectedOrganization,
        fetchAgents,
        selectedRefer,
        formattedFromDate,
        formattedToDate,
        SubscriptionDevice,
        sendIDsToAPI,
    ]);

    const HandleChangePausedAgent = async (id, pause, deleted_at) => {
        if (deleted_at) {
            toast.error('You cannot perform this action against already deleted user');
            return;
        }
        try {
            let newStatus = pause === '0' ? '1' : '0';
            setPauseLoading(true);
            const res = await LeadService.HandlePauseUnpauseAgent(id, newStatus);

            if (res?.data?.success) {
                toast.success(res?.data?.message);
                await fetchAgents(
                    currentPage,
                    searchTermRef.current,
                    selectedValueRef.current,
                    selectedFilterValueRef.current,
                    selectedLocationRef.current,
                    selectedOrganizationRef.current,
                    selectedFilterRef.current
                );
            }
        } catch (error) {
            toast.error(error?.message);
            console.error(error);
        } finally {
            setPauseLoading(false);
        }
    };
    // const HandleMoveToSelf = async (id) => {
    //     try {
    //         const moveToSelf = [id];
    //         setPauseLoading(true);
    //         const res = await LeadService.organizationAgentToSelf(moveToSelf);
    //         if (res?.data?.success) {
    //             toast.success(res.data.message);
    //             await fetchAgents(
    //                 currentPage,
    //                 searchTermRef.current,
    //                 selectedValueRef.current,
    //                 selectedFilterValueRef.current,
    //                 selectedLocationRef.current,
    //                 selectedOrganizationRef.current
    //             );
    //         }
    //     } catch (error) {
    //         toast.error(error.message);
    //     } finally {
    //         setPauseLoading(false);
    //     }
    // };

    const HandleChangeLocation = async (event, newValue) => {
        setSelectedLocation(newValue ? newValue.id : '');
        setCurrentPage(1);
    };
    const HandleChangeOrigination = async (event, newValue) => {
        const newOrganizationId = newValue ? newValue.id : '';
        setSelectedOrganization(newOrganizationId);
        setCurrentPage(1);
        if (newOrganizationId) {
            localStorage.setItem('selectedOrganization', JSON.stringify(newOrganizationId));
        } else {
            localStorage.removeItem('selectedOrganization');
        }
    };

    const HandleChangeLastLogin = async (event, newValue) => {
        setSelectedValue(newValue ? newValue.value : '');
        setCurrentPage(1);
    };
    const HandleChangeFilter = async (event, newValue) => {
        setSelectedFilterValue(newValue ? newValue.value : '');
        setCurrentPage(1);
    };

    const HandleChangeReferedByFilter = async (event, newValue) => {
        setSelectedRefer(newValue ? newValue.value : '');
        setCurrentPage(1);
    };

    const handlePageChange = async (event, value) => {
        setCurrentPage(value);
        await fetchAgents(currentPage, searchTerm, selectedValue, selectedFilterValue, selectedLocation, selectedOrganization);
    };

    const handleSearchChange = (event) => {
        const newSearchTerm = event.target.value;
        setCurrentPage(1);
        setSearchTerm(newSearchTerm);
        if (newSearchTerm) {
            localStorage.setItem('searchTerm', JSON.stringify(newSearchTerm));
        } else {
            localStorage.removeItem('searchTerm');
        }
    };

    const handleClear = () => {
        localStorage.removeItem('searchTerm');
        setSearchTerm('');
        setCurrentPage(1);
        fetchAgents(1, '');
    };

    const handleDeleteOpen = (id) => {
        setOpen(true);
        setDeleteId(id);
    };

    const handleClose = () => {
        setOpen(false);
        setDeleteId(null);
    };

    const adjustTimeBasedOnOffsetForReceivedDataPaymentsDate = (dateString, offsetInHours) => {
        // Ensure the date string is treated as UTC by appending 'Z'
        const date = new Date(`${dateString}Z`);

        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };

    const handleOpenConfirmationModal = async (id, SwitchCustomer) => {
        // Open confirmation modal
        setConfirmationDataMandatory({ id, SwitchCustomer });
        setOpenConfirmationMandatory(true);
    };

    const handleConfirmationMandatory = async () => {
        const { id, SwitchCustomer } = confirmationDataMandatory;
        try {
            setSwitchLoading(true);
            const res = await LeadService.HandleSwitchAgentCustomer(id, SwitchCustomer);
            if (res.data.success) {
                toast.success(res.data.message);
                setOpenConfirmationMandatory(false);
                setSwitchLoading(false);
                fetchAgents(
                    currentPage,
                    searchTerm,
                    selectedValue,
                    selectedFilterValue,
                    selectedLocation,
                    selectedOrganization,
                    selectedRefer,
                    formattedFromDate,
                    formattedToDate,
                    SubscriptionDevice
                );
            }
        } catch (error) {
            toast.error(error.message);
        }
    };
    const truncateMessage = (text) => {
        if (text && text.length > 21) {
            return text.substring(0, 21) + '...';
        }
        return text;
    };
    const handleViewClick = (row) => {
        if (row?.original?.deleted_at) {
            toast.error('This agent user is deleted');
        } else {
            navigate(`/agents-details/${row?.original?.id}`);
        }
    };
    

    const column = [
        {
            accessorKey: 'id',
            header: 'Sr no',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 20,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'ahto',
                },
            },
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                </div>
            ),
            size: 10,
            enableSorting: false,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
        },

        {
            accessorFn: (row) => {
                let fullName;
                if (row?.last_name === null) {
                    fullName = row?.name;
                } else {
                    fullName = `${row?.name} ${row?.last_name}`;
                }
                return truncateMessage(fullName);
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                align: 'left',
                sx: {
                    fontSize: 'auto',
                    fontWeight:'bold'
                },
            },
            muiTableBodyCellProps: ({ row }) => ({
                onClick: () => handleViewClick(row), // Attach the handleViewClick function
                style: {
                    cursor: 'pointer', // Make it clear that it's clickable
                    color: row?.original?.deleted_at ? '#dc1919' : 'inherit', // Highlight deleted users
                    fontWeight:'bold'
                },
            }),
        },
        {
            accessorKey: 'email',
            header: 'Email ID',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            // enableClickToCopy: true,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
        },
        {
            accessorKey: 'phone',
            header: 'Phone Number',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 150,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
        },
        // {
        //     accessorKey: 'location',
        //     header: 'Location',
        //     enableColumnActions: false,
        //     showColumnFilters: false,
        //     enableColumnFilter: false,
        //     enableSorting: false,
        //     size: 100,
        //     muiTableHeadCellProps: {
        //         sx: {
        //             fontSize: 'auto',
        //         },
        //     },
        // },
        // {
        //     accessorKey: 'refer_by',
        //     header: 'Refer Code',
        //     enableColumnActions: false,
        //     showColumnFilters: false,
        //     enableColumnFilter: false,
        //     enableSorting: false,
        //     size: 100,
        //     muiTableHeadCellProps: {
        //         sx: {
        //             fontSize: 'auto',
        //         },
        //     },
        // },
        {
            accessorKey: 'created_at',
            header: 'Member Since',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'subscription_type',
            header: 'Subscription Type',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const subscriptionType = row?.original?.subscription_type;
                const capitalFirstLetter = (type) => {
                    switch (type) {
                        case 'premier':
                            return 'Premier';
                        case 'elite':
                            return 'Elite';
                        case 'founder':
                            return 'Founder';
                        default:
                            return 'Unknown';
                    }
                };
                return <span>{capitalFirstLetter(subscriptionType ? subscriptionType : 'Not Subscribed')}</span>;
            },
        },
        {
            accessorKey: 'always_free',
            header: 'Paying',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ cell }) =>
                cell.getValue() === 0 ? <span>Subscribe to Any Plan</span> : <span style={{ fontWeight: 'bold' }}>Always Subscribed</span>,
        },
        {
            accessorKey: 'trial_start_at',
            header: 'Trial Start',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.trial_start_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'trail_end_at',
            header: 'Trial End',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.trail_end_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'userLastPayment',
            header: 'Last Payment',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.userLastPayment;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'userExpiryPayment',
            header: 'Expire Payment',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.userExpiryPayment;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'deleted_at',
            header: 'Deleted at',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.deleted_at;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'last_login',
            header: 'Last Login',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.last_login;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return 'Never Logged In';
            },
        },
        {
            accessorKey: 'app_version',
            header: 'App Version',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
        },
        {
            accessorKey: 'Update_trail',
            header: 'Update Trial',
            enableColumnActions: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 150, // Adjusted for better UI
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                    textAlign: 'center',
                },
            },
            Cell: ({ row }) => {
                const handleUpdateAgentTrail = (id, trailEndAt) => {
                    const userLastPaymentAvailable = row?.original?.userLastPayment;

                    if (userLastPaymentAvailable) {
                        toast.error('User has already paid their last payment and is not available for trial.');
                        return;
                    }

                    // Call the function to update the trail with the given ID and trail end date
                    UpdateAgentTrail(id, trailEndAt);
                };

                return (
                    <Button
                        variant="outlined"
                        color="warning"
                        size="small"
                        style={{ fontSize: { sx: '10px', md: '10px', lg: '12px' }, borderRadius: '20px', cursor: 'pointer' }}
                        onClick={() => handleUpdateAgentTrail(row.original?.id, row.original?.trail_end_at)}
                    >
                        Update Trial Period
                    </Button>
                );
            },
        },
        {
            accessorKey: 'lofty_user_id',
            header: 'Switch to Customer',
            size: 80,
            enableSorting: false,
            muiTableBodyCellProps: {
                align: 'left',
            },
            Cell: ({ row }) => {
                const { id, lofty_user_id, old_userid } = row?.original;

                // Handler for switch toggle
                const handleToggle = () => {
                    const SwitchCustomer = 'customer';
                    handleOpenConfirmationModal(id, SwitchCustomer);
                };

                return (
                    <>
                        {/* Render the button only if both `lofty_user_id` and `old_userid` are null */}
                        {lofty_user_id === null && old_userid === null ? (
                            <Button
                                onClick={handleToggle}
                                variant="outlined"
                                color="info"
                                size="small"
                                style={{ fontSize: { sx: '10px', md: '10px', lg: '12px' }, borderRadius: '20px', cursor: 'pointer' }}
                            >
                                Switch to Customer
                            </Button>
                        ) : (
                            <span>Not Switchable</span>
                        )}
                    </>
                );
            },
        },

        {
            id: 'actions',
            accessorKey: 'SeeMore',
            header: 'Action',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            size: 80,
            muiTableHeadCellProps: {
                align: 'center',
                sx: {
                    fontSize: 'auto',
                },
            },
            enableSorting: false,
            Cell: ({ row }) => {
                const handleViewClick = () => {
                    if (row?.original?.deleted_at) {
                        return toast.error('This agent user is deleted');
                    } else {
                        navigate(`/agents-details/${row?.original?.id}`);
                    }
                };
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <>
                            {row.original?.organization_id === null ? (
                                <IconButton aria-label="view" onClick={handleViewClick}>
                                    <VisibilityIcon />
                                </IconButton>
                            ) : (
                                <>
                                    {row.original?.deleted_at ? (
                                        <>
                                            {/* <Button
                                            variant="outlined"
                                            color="warning"
                                            size="small"
                                            style={{ fontSize: '8px', borderRadius: '20px', cursor: 'pointer' }}
                                            onClick={() => HandleMoveToSelf(row.original?.id)}
                                            >
                                            Move to Self
                                            </Button> */}
                                        </>
                                    ) : (
                                        <>
                                            {row.original?.pause === '0' ? (
                                                <>
                                                    <Chip
                                                        label="Pause"
                                                        color="success"
                                                        variant="outlined"
                                                        size="small"
                                                        style={{ fontSize: '11px', cursor: 'pointer' }}
                                                        onClick={() =>
                                                            HandleChangePausedAgent(row.original?.id, row.original?.pause, row.original?.deleted_at)
                                                        }
                                                    />
                                                    <IconButton aria-label="view" onClick={handleViewClick}>
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                </>
                                            ) : (
                                                <>
                                                    <Chip
                                                        label="Unpause"
                                                        color="error"
                                                        variant="outlined"
                                                        size="small"
                                                        style={{ fontSize: '11px', cursor: 'pointer' }}
                                                        onClick={() =>
                                                            HandleChangePausedAgent(row.original?.id, row.original?.pause, row.original?.deleted_at)
                                                        }
                                                    />
                                                    <IconButton aria-label="view" onClick={handleViewClick}>
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    </div>
                );
            },
        },
    ];

    useEffect(() => {
        const emailSentTimestamp = localStorage.getItem('emailSentTimestamp');
        if (emailSentTimestamp) {
            const timeElapsed = Date.now() - parseInt(emailSentTimestamp, 10);
            if (timeElapsed < 480000) {
                // If less than 2 minutes have passed
                setButtonVisible(false);
                setTimeout(() => {
                    setButtonVisible(true);
                    localStorage.removeItem('emailSentTimestamp');
                }, 480000 - timeElapsed);
            }
        }
    }, []);

    const handleEmailSend = async () => {
        if (selectedIds.length == 0) {
            return toast.error('Please select any users to send email');
        }
        try {
            setIsLoadingEmail(true);
            setButtonVisible(false);
            const res = await LeadService.EmailToAgents(selectedIds);
            setIsLoadingEmail(false);
            if (res?.data?.success) {
                toast.success(res.data.message);

                await setSelectedIds('');
                setRowSelection({});
                const timestamp = Date.now();
                localStorage.setItem('emailSentTimestamp', timestamp);
                setTimeout(() => {
                    setButtonVisible(true);
                    localStorage.removeItem('emailSentTimestamp');
                }, 480000);
                return;
            }
        } catch (error) {
            toast.error(error.message);
            console.error(error);
        }
    };

    const adjustTimeBasedOnOffsetForSendData = (date, offsetInHours) => {
        const dateObj = new Date(date);
        const utcDate = new Date(dateObj.toUTCString()); // Convert to UTC
        if (offsetInHours > 0) {
            utcDate.setHours(utcDate.getHours() - offsetInHours);
        } else {
            utcDate.setHours(utcDate.getHours() - offsetInHours);
        }
        return utcDate;
    };

    const formatDate = (date) => {
        return date ? dayjs(date).format('DD-MM-YYYY HH:mm:ss') : null;
    };

    const handleSearchClick = async (fromDate, toDate) => {
        const currentDate = new Date();
        const formattedCurrentDate = formatDate(currentDate);

        if (!fromDate) {
            return toast.error('Please select the from date.');
        }

        if (!toDate) {
            return toast.error('Please select the to date.');
        }

        if (toDate < fromDate) {
            return toast.error('Please select a to date later than the start date.');
        }

        if (fromDate !== null) {
            localStorage.setItem('fromDate', JSON.stringify(fromDate));
        }
        if (toDate !== null) {
            localStorage.setItem('toDate', JSON.stringify(toDate));
        }

        const userOffset = getUserOffset();
        const formattedFrom = formatDate(adjustTimeBasedOnOffsetForSendData(fromDate, userOffset));
        const formattedTo = formatDate(adjustTimeBasedOnOffsetForSendData(toDate, userOffset));

        // Set formatted dates in state
        setFormattedFromDate(formattedFrom);
        setFormattedToDate(formattedTo);
        localStorage.setItem('formattedFromDate', JSON.stringify(formattedFrom));
        localStorage.setItem('formattedToDate', JSON.stringify(formattedTo));

        fetchAgents(
            1,
            searchTerm,
            selectedValue,
            selectedFilterValue,
            selectedLocation,
            selectedOrganization,
            selectedRefer,
            formattedFrom,
            formattedTo
        );
    };

    useEffect(() => {
        // Retrieve raw dates from localStorage
        const savedFromDate = localStorage.getItem('fromDate');
        const savedToDate = localStorage.getItem('toDate');

        if (savedFromDate) {
            const parsedFromDate = dayjs(JSON.parse(savedFromDate));
            setFromDate(parsedFromDate);
            const userOffset = getUserOffset();
            const formattedFrom = formatDate(adjustTimeBasedOnOffsetForSendData(parsedFromDate, userOffset));
            setFormattedFromDate(formattedFrom);
        }

        if (savedToDate) {
            const parsedToDate = dayjs(JSON.parse(savedToDate));
            setToDate(parsedToDate);
            const userOffset = getUserOffset();
            const formattedTo = formatDate(adjustTimeBasedOnOffsetForSendData(parsedToDate, userOffset));
            setFormattedToDate(formattedTo);
        }
        const savedSearchTerm = localStorage.getItem('searchTerm');
        if (savedSearchTerm) {
            setSearchTerm(JSON.parse(savedSearchTerm));
        }

        const savedSubscriptionDevice = localStorage.getItem('SubscriptionDevice');
        if (savedSubscriptionDevice) {
            setSubscriptionDevice(JSON.parse(savedSubscriptionDevice));
        }

        const savedSelectedOrganization = localStorage.getItem('selectedOrganization');
        if (savedSelectedOrganization) {
            setSelectedOrganization(JSON.parse(savedSelectedOrganization));
        }

        const storedTags = localStorage.getItem('selectedTags');
        if (storedTags) {
            const parsedTags = JSON.parse(storedTags);
            const uniqueTags = parsedTags.filter(
                (tag, index, self) => self.findIndex((t) => t.id === tag.id) === index
            );
            setSelectedTags(uniqueTags);
        }
    
        const storedIDs = localStorage.getItem('sendIDsToAPI');
        if (storedIDs) {
            setSendIDsToAPI(JSON.parse(storedIDs));
        }
    }, []);

    const clearALLState = () => {
        localStorage.removeItem('fromDate');
        localStorage.removeItem('toDate');
        localStorage.removeItem('formattedFromDate');
        localStorage.removeItem('formattedToDate');
        localStorage.removeItem('searchTerm');
        localStorage.removeItem('SubscriptionDevice');
        localStorage.removeItem('selectedOrganization');
        localStorage.removeItem('selectedTags');
        localStorage.removeItem('sendIDsToAPI');

        setFromDate('');
        setToDate('');
        setFormattedFromDate('');
        setFormattedToDate('');
        setSearchTerm('');
        setSubscriptionDevice('');
        setSelectedOrganization('');
        setSelectedTags([]);
        setSendIDsToAPI([]);
        setSelectedLocation('');
        setSelectedRefer('');
        setSelectedFilterValue('');
        setSelectedValue('');
        fetchAgents(1, '', '', '', '','');
    };

    const UpdateAgentTrail = (id, trailEndAt) => {
        setCurrentId(id);
        setUpdatedDate(dayjs(trailEndAt));
        setTrailModal(true);
    };
    const handleDaysChange = (days) => {
        setSelectedDays(days);
        const newDate = dayjs(updatedDate).add(days, 'day'); // Update based on current date
        setUpdatedDate(newDate); // Update displayed date
    };
    const handleSaveTrail = async () => {
        if (selectedDays === null) {
            toast.error('please select the days');
            return;
        }
        try {
            setLoadingTrial(true);
            const res = await LeadService.changeAgentTrial(currentId, selectedDays);
            if (res.data.success) {
                toast.success(res.data.message);
                setTrailModal(false);
                setSelectedDays(null);
                fetchAgents(
                    currentPage,
                    searchTerm,
                    selectedValue,
                    selectedFilterValue,
                    selectedLocation,
                    selectedOrganization,
                    selectedRefer,
                    formattedFromDate,
                    formattedToDate,
                    SubscriptionDevice
                );
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoadingTrial(false);
        }
    };

    const getAllTags = async () => {
        try {
            const res = await LeadService.getTags();
            if (res.data.success) {
                const formattedTags = res.data.data.map((tag) => ({
                    title: tag?.tag, // Use 'tag' for display
                    id: tag?.id, // Use 'id' for selection
                }));
                setTags(formattedTags);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        getAllTags();
    }, []);

    // Handle selection Tags id
    const handleChangeTags = (event, value) => {
        const uniqueTags = value.filter(
            (tag, index, self) => self.findIndex((t) => t.id === tag.id) === index
        );
        setSelectedTags(uniqueTags);
        if (uniqueTags.length > 0) {
            localStorage.setItem('selectedTags', JSON.stringify(uniqueTags));
        } else {
            localStorage.removeItem('selectedTags');
        }
        const selectedIDs = uniqueTags.map((tag) => tag.id);
        setSendIDsToAPI(selectedIDs);
        if (selectedIDs.length > 0) {
            localStorage.setItem('sendIDsToAPI', JSON.stringify(selectedIDs));
        } else {
            localStorage.removeItem('sendIDsToAPI');
        }
    };
    
    return (
        <>
            <div style={{ marginBottom: '15px' }}> {isLoadingEmail || isLoading || (PauseLoading && <LinearProgress />)}</div>
            <div style={{ marginBottom: '25px' }}>
                <SuperAdmin_Cards />
            </div>
            <Box className={classes.SuperAdminAgentsContainer}>
                <Card
                    sx={{
                        padding: {
                            xs: '10px',
                            sm: '15px',
                            md: '20px'
                        },
                        borderRadius: '22px',
                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                        backgroundColor: 'white',
                        width: 'auto',
                        transform: 'scale(1)',
                        transition: 'transform 0.3s ease-in-out',
                        display: 'grid',
                        gap: '20px',
                        justifyContent: 'center',
                    }}
                >
                    <Box style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px', gap: '5px', flexWrap: 'wrap' }}>
                        <Autocomplete
                            options={options}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Last Login" />}
                            value={options.find((option) => option.value === selectedValue) || null}
                            onChange={HandleChangeLastLogin}
                            // onChange={(event, newValue) => setSelectedValue(newValue ? newValue.value : '')}
                            disabled={isLoading}
                            className={classes.superAdminAgentFilter}
                            sx={{
                                width: {
                                    xs: "150px",
                                    sm: "200px",
                                    md: "250px"
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                            }}
                        />

                        <Autocomplete
                            options={filterOptions}
                            getOptionLabel={(filterOptions) => filterOptions.label}
                            renderInput={(params) => <TextField {...params} label="Filters" />}
                            value={filterOptions.find((filterOptions) => filterOptions.value === selectedFilterValue) || null}
                            onChange={HandleChangeFilter}
                            disabled={isLoading}
                            className={classes.superAdminAgentFilter}
                            sx={{
                                width: {
                                    xs: "150px",
                                    sm: "200px",
                                    md: "250px"
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                            }}
                        />

                        <div onScroll={handleScroll}>
                            <Autocomplete
                                options={getReferCode} // use the state populated with transformed data
                                getOptionLabel={(option) => option.label} // display name and last name as the label
                                value={getReferCode.find((option) => option.value === selectedRefer) || null} // selected referral_code
                                onChange={HandleChangeReferedByFilter}
                                disabled={isLoading}
                                ListboxProps={{ onScroll: handleScroll }}
                                onInputChange={handleInputChange}
                                loading={IsLoadingRef}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Refer By"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {IsLoadingRef ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                                className={classes.superAdminAgentFilter}
                                sx={{
                                    width: {
                                        xs: "150px",
                                        sm: "200px",
                                        md: "250px"
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </div>
                        <TextField
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder="Search name, email "
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleClear} aria-label="clear search">
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            className={classes.superAdminAgentFilter}
                            sx={{
                                width: {
                                    xs: "150px",
                                    sm: "200px",
                                    md: "250px"
                                },  
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                            }}
                        />
                    </Box>
                    <Box style={{ display: 'grid', gap: '20px' }}>
                        <Box style={{ display: 'grid', gap: '4px' }}>
                            <Box style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                <Box>
                                    <Autocomplete
                                        options={getPefferedLocation}
                                        getOptionLabel={(getPefferedLocation) => getPefferedLocation.region_name}
                                        renderInput={(params) => <TextField {...params} label="Preferred Location" />}
                                        value={getPefferedLocation?.find((location) => location.id === selectedLocation) || null}
                                        onChange={HandleChangeLocation}
                                        disabled={isLoading}
                                        className={classes.superAdminAgentFilter}
                                        sx={{
                                            width: {
                                                xs: "150px",
                                                sm: "200px",
                                                md: "250px"
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '12px',
                                            },
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <Autocomplete
                                        options={getOrganization}
                                        getOptionLabel={(getOrganization) => getOrganization.organization_name}
                                        renderInput={(params) => <TextField {...params} label="Select Organization" />}
                                        value={getOrganization?.find((location) => location.id === selectedOrganization) || null}
                                        onChange={HandleChangeOrigination}
                                        disabled={isLoading}
                                        className={classes.superAdminAgentFilter}
                                        sx={{
                                            width: {
                                                xs: "150px",
                                                sm: "200px",
                                                md: "250px"
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '12px',
                                            },
                                        }}
                                    />
                                </Box>

                                <Box>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            className={classes.superAdminAgentFilter}
                                            sx={{
                                                width: {
                                                    xs: "150px",
                                                    sm: "200px",
                                                    md: "250px"
                                                },
                                                overflow: 'hidden',
                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                            value={fromDate}
                                            onChange={(newDate) => setFromDate(newDate)}
                                        />
                                    </LocalizationProvider>
                                </Box>
                                <Box>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            className={classes.superAdminAgentFilter}
                                            sx={{
                                                width: {
                                                    xs: "150px",
                                                    sm: "200px",
                                                    md: "250px"
                                                },
                                                overflow: 'hidden',
                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                            value={toDate}
                                            onChange={(newDate) => setToDate(newDate)}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Box>
                            <Box style={{ marginTop: '10px', display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                <Autocomplete
                                    options={SubscriptionType}
                                    getOptionLabel={(SubscriptionType) => SubscriptionType.charAt(0).toUpperCase() + SubscriptionType.slice(1)}
                                    renderInput={(params) => <TextField {...params} label="Subscription Types" />}
                                    value={SubscriptionType?.find((subscription) => subscription === SubscriptionDevice) || null}
                                    onChange={HandleChangeSubscriptionType}
                                    disabled={isLoading}
                                    sx={{
                                        width: {
                                            xs: "150px",
                                            sm: "200px",
                                            md: "250px"
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                                <Autocomplete
                                    multiple
                                    id="tags-autocomplete"
                                    options={tags} // Full list of tag options
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.title} // Display the 'title'
                                    onChange={handleChangeTags} // Handle selection
                                    value={tags.filter((tag) => selectedTags.some((selected) => selected.id === tag.id))}
                                    renderOption={(props, option, { selected }) => (
                                        <li key={option.id || option.title} {...props}>
                                            <Checkbox style={{ marginRight: 8 }} checked={selected} />
                                            {option.title}
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} label="Tags" placeholder="Select tags" />}
                                    sx={{
                                        width: {
                                            xs: "150px",
                                            sm: "200px",
                                            md: "250px"
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </Box>

                            <Box style={{ display: 'flex', gap: '5px', marginTop: '20px', textAlign: 'center', flexWrap: 'wrap' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: 'auto',
                                        height: 'auto',
                                        borderRadius: '12px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        border: '1px solid #587DBF',
                                        backgroundColor: '#5379BD',
                                        color: 'white',
                                        fontFamily: 'inherit',
                                    }}
                                    onClick={() => handleSearchClick(fromDate, toDate)}
                                >
                                    {' '}
                                    Search By Date
                                </Button>
                                <Button
                                    style={{
                                        width: 'auto',
                                        height: '40px',
                                        border: '1px solid gray',
                                        background: '#bababa',
                                        borderRadius: '8px',
                                        fontWeight: 'bold',
                                        marginLeft: '5px',
                                        cursor: 'pointer',
                                        marginTop: '5px',
                                        marginBottom: 'px',
                                        color: 'black',
                                    }}
                                    sx={{ fontFamily: 'inherit' }}
                                    onClick={clearALLState}
                                >
                                    Clear
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Card>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px' }}>
                    <div>
                        <Typography style={{ fontSize: '36px', fontWeight: '700' }} className="services-animated-text">
                            Agent Users
                        </Typography>
                    </div>
                    <div style={{ display: 'flex', gap: '15px' }}>
                        <>
                            {buttonVisible && (
                                <div style={{ marginTop: '10px', position: 'relative' }} onClick={handleEmailSend}>
                                    <Button
                                        style={{ cursor: 'pointer' }}
                                        onMouseEnter={() => setEmailShowTooltip(true)}
                                        onMouseLeave={() => setEmailShowTooltip(false)}
                                    >
                                        <ForwardToInboxIcon />
                                        {emailShowTooltip && (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '100%',
                                                    left: '1%',
                                                    transform: 'translateX(-50%)',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                                    color: '#fff',
                                                    padding: '5px 10px',
                                                    borderRadius: '5px',
                                                    fontSize: '11px',
                                                    whiteSpace: 'nowrap',
                                                    marginBottom: '4px',
                                                }}
                                            >
                                                Send login Credential
                                            </div>
                                        )}
                                    </Button>
                                </div>
                            )}
                        </>
                    </div>
                </div>
                <ThemeProvider theme={theme}>
                    <GlobalStyles
                        styles={{
                            '::-webkit-scrollbar': {
                                width: '14px', // Set the desired width for the scrollbar
                            },
                            '::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                borderRadius: '10px', // Set the border radius for a rounded effect
                            },
                        }}
                    />

                    <div className={classes.tableOverviewStyle} style={{}}>
                        <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                            <Table column={column} data={GetAllAgents} isLoading={isLoading} />
                        </Card>
                    </div>
                    <Pagination
                        count={totalPages}
                        color="primary"
                        page={currentPage}
                        onChange={handlePageChange}
                        style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                    />
                </ThemeProvider>
            </Box>
            {/* delete modal */}
            <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Box
                            sx={{
                                display: 'grid',
                                padding: '10px',
                                gap: '10px',
                            }}
                        >
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                <Box>
                                    <DeleteIcon style={{ fontSize: '34px' }} />
                                </Box>
                                <Box style={{ display: 'grid', gap: '10px' }}>
                                    <div>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this user?</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '16px', color: '#252F46' }}>
                                            This action will delete this user permanently, and you can not undo this.
                                        </span>
                                    </div>
                                </Box>
                            </Box>
                        </Box>

                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Button
                                onClick={handleClose}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: 'white',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: '#252F46',
                                    fontSize: '15px',
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: '#5379BD',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: 'white',
                                    fontSize: '15px',
                                }}
                            >
                                Delete
                            </Button>
                        </Box>
                    </div>
                </Box>
            </Modal>
            {/* update trial modal */}
            <Modal open={trailModal}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        borderRadius: '22px',
                        p: 3,
                    }}
                    className='modal-resp-settings'
                >
                    {/* Header with Close Icon */}
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">Update Trial</Typography>
                        <IconButton onClick={() => setTrailModal(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Date Picker (Non-editable) */}
                    <Box sx={{ marginTop: '20px' }}>
                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Trail End Date"
                                value={updatedDate}
                                readOnly
                                renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
                                sx={{
                                    width: 350,
                                }}
                            />
                        </LocalizationProvider> */}

                        
                        <Autocomplete
                            options={[...Array(30).keys()].map((i) => i + 1)} // Days 1 to 30
                            getOptionLabel={(option) => `${option} Day${option > 1 ? 's' : ''}`}
                            value={selectedDays}
                            onChange={(_, value) => handleDaysChange(value)}
                            renderInput={(params) => <TextField {...params} label="Select Days" margin="normal" fullWidth />}
                            sx={{
                                width: '100%',
                            }}
                        />
                    </Box>

                    {/* Save Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            mt: 2,
                            backgroundColor: '#5379BD',
                            borderRadius: '12px',
                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                        }}
                        onClick={handleSaveTrail}
                        disabled={LoadingTrial}
                    >
                        Save {LoadingTrial && <CircularProgress size="20px" sx={{ visibility: LoadingTrial ? '' : 'hidden' }} />}
                    </Button>
                </Box>
            </Modal>
            {/* confirmation modal for agent switch */}
            <Dialog open={openConfirmationMandatory} TransitionComponent={Transition} keepMounted aria-describedby="alert-dialog-slide-description">
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>Are you sure you want to switch this agent to a customer.?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmationMandatory(false)}>NO</Button>
                    <Button onClick={handleConfirmationMandatory} disabled={switchLoading}>
                        {' '}
                        {switchLoading ? 'Processing...' : 'YES'}
                    </Button>
                </DialogActions>
            </Dialog>

            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal}/>
        </>
    );
};

export default Super_Admin_Agents;
